jQuery(document).ready(function($){  
  $(document).on('click','.language-wrapper .language-link',function(e){
    e.preventDefault();
    let parent_handler = $(this).parent();
    let submenu = $(parent_handler).find('.language-options');
    if ($(parent_handler).hasClass('drop-active')) {
        $(parent_handler).removeClass('drop-active');
        $(submenu).slideUp();        
    } else {
        $(parent_handler).addClass('drop-active');
        $(submenu).slideDown();
    }
  });
  var $tooltip = $('#image-tooltip');
  var $tooltipImg = $('#image-tooltip img');

  console.log('s');

  $('.collection-hover').on('mousemove', function (e) {
    var imageUrl = $(this).data('image');
    if (imageUrl) {
      $tooltipImg.attr('src', imageUrl);
      $tooltip.css({
        top: e.clientY + 20 + 'px', 
        left: e.clientX + 20 + 'px',
        display: 'block'
      });
    }
  });

  $('.collection-hover').on('mouseleave', function () {
    $tooltip.hide();
    $tooltipImg.attr('src', '');
  });
  

  $('.about-tabs a').on('click',function(e){
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);

    if ($target.length) {
      $('html, body').animate({
        scrollTop: $target.offset().top
      }, 800); // Duration in ms (800ms = 0.8s)
    }
  });

  $(document).on('change','.filter-tags',function(){
    let selectedTag = $(this).val();
    // Get the current collection handle from the URL
    let pathParts = window.location.pathname.split('/');
    let collectionHandle = pathParts.includes('collections') ? pathParts[2] : 'all';
    
    // Redirect to the collection with the selected tag
    window.location.href = '/collections/' + collectionHandle + '/' + selectedTag;
  });
  if ($(window).width() < 1025) {
    // $('.custom-sidebar-menu .menu:not(.dropdown-child) li:not(:first-child) > a').attr('href', '#');
    $('.custom-sidebar-menu .menu:not(.dropdown-child) li:not(:first-child) > a').on('click',function(e){
      e.preventDefault();
      let dropdowns = $(this).parent().find('.dropdown-child'); 
      let menu_link = $(this).parent();
      if ($(menu_link).hasClass('active')) {
        $(dropdowns).slideUp();
        $(menu_link).removeClass('active');
      } else {
        $('.custom-sidebar-menu .menu:not(.dropdown-child) li:not(:first-child)').removeClass('active');
        $('.dropdown-child').slideUp();
        $(menu_link).addClass('active');
        $(dropdowns).slideDown();
      }

    });
  }

  // $(".t4s-footer-link:contains('Jewellery Care')").attr("data-popup-open", "jewellery-case-popup");
 $('a[href$="#jewellery-case-popup"]').attr("data-popup-open", "jewellery-case-popup");

  $('#shopify-block-AR0FWZHBmTnl5OE5xW__infinite_options_app_block_ddKM7N').insertAfter('.custom-product-description');

  $(document).on('click','.custom-dropdown',function(){
    let drop_menus = $(this).find('.dropdown-menu');
    if ($(this).hasClass('drop-active')) {
      $(this).removeClass('drop-active');
      $(drop_menus).slideUp();
    } else {
      $(this).addClass('drop-active');
      $(drop_menus).slideDown();
    }
  });

  
});

jQuery(document).ready(function($){
  (function(){
    var $popup = $('.product-popup');
    if (!$popup.length) return;

    var triggerPages = String($popup.data('trigger-pages') || 'product');
    var cookieHours  = parseInt($popup.data('cookie-hours'), 10);  if (isNaN(cookieHours) || cookieHours < 0) cookieHours = 24;
    var delayMs      = parseInt($popup.data('delay'), 10);         if (isNaN(delayMs) || delayMs < 0) delayMs = 0;
    var hideMobile   = String($popup.data('hide-mobile')) === 'true';

    // Show only on product pages if selected
    var onProduct = $('body').is('.template-product') || window.location.pathname.indexOf('/products/') !== -1;
    if (triggerPages === 'product' && !onProduct) return;

    // Respect "hide on mobile"
    if (hideMobile && window.matchMedia('(max-width: 767px)').matches) return;

    var COOKIE_NAME = 'product_popup_closed';

    function setCookie(name, value, hours) {
      var d = new Date();
      d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/';
    }
    function getCookie(name) {
      var cname = name + '=';
      var parts = document.cookie.split(';');
      for (var i=0;i<parts.length;i++){
        var c = parts[i].trim();
        if (c.indexOf(cname) === 0) return c.substring(cname.length);
      }
      return '';
    }

    if (!getCookie(COOKIE_NAME)) {
      setTimeout(function(){
        $popup.css('display', 'flex').hide().fadeIn('slow');
      }, delayMs);
    }

    $(document).on('click', '.product-popup .pop-close', function(){
      $popup.fadeOut();
      if (cookieHours > 0) setCookie(COOKIE_NAME, 'true', cookieHours);
    });
  })();
});
